// @ts-check
import React from 'react'
import { Header } from './Header'
import cn from 'classnames'
import styles from './style.css'

/**
 * @param {{
 * title?: string,
 * caption?: string,
 * children?: React.ReactNode,
 * onSubmit?: {(event: React.FormEvent): void},
 * className?: string }} props
 */
const Form = ({ title, children, caption, className, onSubmit }) => (
  <form className={cn(styles.form, className)} onSubmit={onSubmit}>
    {title && caption && <Header title={title}>{caption}</Header>}
    {children}
  </form>
)

Form.defaultProps = {
  children: null,
  caption: null
}

export { Form }
